import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { theme, TYPE_CONFIG } from '@garnish/constants';

import { useResponsive } from '../../../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const BenefitCardTitle = (props: BenefitCardImgProps) => {
  const { children: title } = props;

  const { match } = useResponsive();

  const titleResponsiveStyles = match([
    styles.titleXS,
    styles.titleSM,
    styles.titleMD,
  ]);
  const titleStyles = [styles.title, titleResponsiveStyles];

  const textWithoutLineBreaks = title.replace(/[\n\r]/g, ' ');
  const formattedText = match([textWithoutLineBreaks, title]);

  return <Text style={titleStyles}>{formattedText}</Text>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.KALE,
    textAlign: 'center',
    textTransform: 'uppercase',
    marginBottom: theme.spacing['4'],
  },
  titleXS: {
    ...TYPE_CONFIG.BODY['14_BOLD'],
    textAlign: 'left',
    textTransform: 'none',
    marginBottom: 0,
  },
  titleSM: {
    ...TYPE_CONFIG.TITLE['24'],
  },
  titleMD: {
    ...TYPE_CONFIG.TITLE['32'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type BenefitCardImgProps = {
  readonly children: string;
};
